module.exports = __webpack_public_path__ + "img/goal-13.c5b226b1.png";